import { UserExcursion } from "@/services/api/UserExcursion/type";
import { formatDateString } from "@/utils/stringUtils";
import { useState } from "react";

export const DATE_FILTER_OPTIONS = [
  "Qualquer momento",
  "Último mês",
  "Última semana",
  "Hoje",
];

const useFilterUserExcursionsByDate = (userExcursions: UserExcursion[]) => {
  const [dateFilterIndex, setDateFilterIndex] = useState(0);

  const checkIfDateIsFromPreviousTimeInterval = (
    date: string,
    daysAgo: number
  ) => {
    const formattedDate = new Date(date);

    const currentDate = new Date();

    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(currentDate.getDate() - daysAgo);

    return formattedDate >= thirtyDaysAgo && formattedDate <= currentDate;
  };

  const checkIfDateIsFromToday = (date: string) =>
    formatDateString(date) === formatDateString(new Date().toISOString());

  const filteredUserExcursions =
    dateFilterIndex === 0
      ? userExcursions
      : dateFilterIndex === 1
        ? userExcursions?.filter((userExcursion) =>
            checkIfDateIsFromPreviousTimeInterval(userExcursion.createdAt, 30)
          )
        : dateFilterIndex === 2
          ? userExcursions?.filter((userExcursion) =>
              checkIfDateIsFromPreviousTimeInterval(userExcursion.createdAt, 7)
            )
          : userExcursions?.filter((userExcursion) =>
              checkIfDateIsFromToday(userExcursion.createdAt)
            );

  return { filteredUserExcursions, dateFilterIndex, setDateFilterIndex };
};

export default useFilterUserExcursionsByDate;
